import React from 'react';
import { captureButtonPress } from '../../features/analytics';
import { Container } from './styledComponents/Container';
import { COLORS } from '../../style/colors';

interface Props {
  color?: string;
}

export const ContactUsLink: React.FC<Props> = ({
  color = COLORS.lightTextColor,
}) => {
  return (
    <Container>
      <a
        href="mailto:seeker@ancient-world.co"
        onClick={() => {
          captureButtonPress({
            page: window.location.pathname,
            buttonName: 'ContactUs',
          });
        }}
      >
        seeker@ancient-world.co
      </a>
    </Container>
  );
};
